import { Box, Button, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom"; // Para la redirección
import { InputSoloNumeros } from "../../../components/InputPersonalizado";
import { onboardingTarjetasApi } from "../../../api/onboardingTarjetas";
import { AppStore } from "../../../redux/stores";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { resetLoading, updateLoading } from "../../../redux/states/loading";

interface OkResponse {
  open: boolean;
  message: string;
  severity: string;
}

interface ReingresarCelularProps {
  onSetOkResponse: (response: OkResponse) => void;
}

const ReingresarCelular: React.FC<ReingresarCelularProps> = ({ onSetOkResponse }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showQuestion, setShowQuestion] = useState(true); // Muestra la pregunta inicial
  const [stTelefono, setTelefono] = useState("");
  const navigate = useNavigate(); // Para la redirección
  const dispatch = useDispatch();
  const idTramite = useSelector((state: AppStore) => state.user.idTramite);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const volver = () => {
    setTelefono("");
    setShowPopup(false);
  };

  const toggleTelefono = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTelefono(event.target.value);
  };

  const handleYesClick = () => {
    navigate("/private/Gracias", { replace: true });
  };

  const handleNoClick = () => {
    setShowQuestion(false); // Cambia la UI para mostrar la opción de reenviar código
  };

  async function ReenviarLink() {
    try {
      if (stTelefono.trim() === "") {
        onSetOkResponse({
          open: true,
          message: "Debe ingresar un número de teléfono!",
          severity: "warning",
        });
      } else {
        dispatch(updateLoading({ openLM: true, messageLM: "Reenviando link a su celular..." }));
        const response = await onboardingTarjetasApi.reEnviarLink(stTelefono, idTramite);
        dispatch(resetLoading());

        if (response.data.resultado) {
          onSetOkResponse({ open: true, message: "Se envió correctamente", severity: "success" });
          setTelefono("");
          setShowPopup(false);
          setShowQuestion(true); // 🔹 Volver a la pregunta "¿Recibiste el link?"
        } else {
          onSetOkResponse({ open: true, message: response.data.errores, severity: "error" });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }


  return (
    <div className="App">
      <Grid container>
        <Grid item xs={12} justifyContent="center" alignItems="center" mb={10}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%", // Asegura que ocupe todo el ancho disponible
            }}
          >
            <Box
              sx={{
                backgroundColor: "#E4FFFA",
                padding: "10px",
                marginTop: 5,
                width: "80vw",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.501)",
                textAlign: "center", // Centra el texto dentro del Box
                display: "flex",
                flexDirection: "column", // Asegura que los elementos se apilen verticalmente
                alignItems: "center", // Centra los elementos en el eje horizontal
                justifyContent: "center", // Centra en el eje vertical
              }}
            >
              {showQuestion ? (
                <>
                  <Typography variant="h6">¿Recibiste el link?</Typography>
                  <Box mt={2}>
                    <Button
                      variant="contained"
                      color="error"
                      sx={{ margin: 1 }}
                      onClick={handleNoClick}
                    >
                      No
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ margin: 1 }}
                      onClick={handleYesClick}
                    >
                      Sí
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  <Typography variant="body1">
                    Por favor, reintentá enviarlo haciendo click&nbsp;
                    <span
                      style={{
                        color: "#ff1744",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                      onClick={togglePopup}
                    >
                      AQUÍ
                    </span>
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>

      {showPopup && (
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: 250, sm: 300, md: 500 },
            bgcolor: "background.paper",
            border: "1px solid #000",
            borderRadius: 5,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h1" textAlign={"center"}>
            Validá o modificá tu celular para reenviarte un link
          </Typography>
          <div style={{ textAlign: "center" }}>
            <InputSoloNumeros value={stTelefono} valueLabel="Número de celular" onChange={toggleTelefono} />
          </div>
          <div style={{ textAlign: "center" }}>
            <Button variant="contained" color="success" style={{ margin: 15 }} onClick={volver}>
              Volver
            </Button>
            <Button variant="contained" style={{ margin: 15 }} onClick={ReenviarLink}>
              Enviar
            </Button>
          </div>
        </Box>
      )}
    </div>
  );
};

export default ReingresarCelular;
